<script>
export default {
  name: 'TwProgressBar',
  props: {
    progress: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'md'
    },
    variant: {
      type: String,
      default: 'amber'
    }
  },
  computed: {
    barSize() {
      const sizes = {
        'sm': 'h-2.5',
        'md': 'h-3',
        'lg': 'h-6'
      }
      return sizes[this.size]
    },
    barVariant() {
      const variants = {
        'amber': 'bg-amber-500',
        'blue': 'bg-blue-600',
        'green': 'bg-green-500',
      }
      return variants[this.variant]
    }
  }
}

</script>

<template>
  <div :class="['w-full bg-gray-200 rounded-full',barSize]">
    <div :class="['rounded-full',barSize, barVariant]" :style="`width: ${progress < 100?progress:100}%`" />
  </div>
</template>

<style scoped>

</style>
